import Layout from '@/layout/paycools-index.vue'

export const transitionRouter = {
  path: '/transition',
  component: Layout,
  redirect: '/transition/payin',
  name: 'Transition_Manger',
  meta: { title: 'transaction_manage', icon: 'transaction' },
  children: [
    {
      path: 'transSum',
      name: 'Transaction_Manage_Summary',
      component: () => import('@/views/paycools/data/transaction-summary.vue'),
      meta: {
        title: 'transaction_summary', noCache: false,
        auth: ['AUTH_CODE_TRANSACTION_STATISTICS']
      }
    },
    {
      path: 'payin',
      name: 'Transaction_Manage_Payin',
      component: () => import('@/views/paycools/data/payin.vue'),
      meta: {
        title: 'payin', noCache: false,
        auth: ['AUTH_CODE_PAYMENT']
      }
    },
    {
      path: 'refund',
      name: 'Transaction_Manage_Refund',
      component: () => import('@/views/paycools/data/refund.vue'),
      meta: {
        title: 'refund', noCache: false,
        auth: ['AUTH_CODE_TRANSACTION_REFUND']
      }
    },
    {
      path: 'payout',
      name: 'Transaction_Manage_Payout',
      component: () => import('@/views/paycools/data/payout.vue'),
      meta: {
        title: 'payout', noCache: false,
        auth: ['AUTH_CODE_PAYOUT']
      }
    },
    {
      path: 'fx',
      name: 'Transaction_Manage_FX',
      component: () => import('@/views/paycools/data/fx-transactions.vue'),
      meta: {
        title: 'fx_transactions', noCache: false,
        auth: ['AUTH_CODE_FOREIGN_EXCHANGE']
      }
    },
    {
      path: 'loan',
      name: 'Transaction_Manage_Loan',
      component: () => import('@/views/paycools/data/loan.vue'),
      meta: {
        title: 'loan', noCache: false,
        auth: ['AUTH_CODE_CREDIT_LOAN']
      }
    },
    {
      path: 'repayment',
      name: 'Transaction_Manage_Repayment',
      component: () => import('@/views/paycools/data/repayment.vue'),
      meta: {
        title: 'repayment', noCache: false,
        auth: ['AUTH_CODE_CREDIT_PAYMENT']
      }
    },
    {
      path: 'splitTransaction',
      name: 'Split_Transaction',
      component: () => import('@/views/paycools/data/split-transaction.vue'),
      meta: {
        title: 'split_transaction', noCache: false,
        auth: ['AUTH_CODE_SPLIT_PAYMENT']
      }
    },
    {
      path: 'cardVerification',
      name: 'Card_Verification',
      component: () => import('@/views/paycools/data/card-verification.vue'),
      meta: {
        title: 'card_verification_list', noCache: false,
        auth: ['AUTH_CARD_VALIDATION_MERCHANT_TRANSACTION']
      }
    },
    {
      path: 'paymentSlipValidation',
      name: 'Payment_Slip_Validation',
      component: () => import('@/views/paycools/data/payment-slip-validation.vue'),
      meta: {
        title: 'payment_slip_validation_list', noCache: false,
        auth: ['AUTH_PAYMENT_SLIP_VALIDATION_TRANSACTION']
      }
    }
  ]
}

export const transitionAgentRouter = {
  path: '/transition/agent',
  component: Layout,
  redirect: '/transition/agent/payin',
  name: 'Transition_Manger',
  meta: { title: 'transaction_manage', icon: 'transaction' },
  children: [
    {
      path: 'transSum',
      name: 'Transaction_Manage_Agent_Summary',
      component: () => import('@/views/paycools/data-agent/transaction-summary.vue'),
      meta: {
        title: 'transaction_summary', noCache: false,
        auth: ['ROLE_AUTH_AGENT_ADMIN']
      }
    },
    {
      path: 'payin',
      name: 'Transaction_Manage_Agent_Payin',
      component: () => import('@/views/paycools/data-agent/payin.vue'),
      meta: {
        title: 'payin', noCache: false,
        auth: ['ROLE_AUTH_AGENT_ADMIN']
      }
    },
    {
      path: 'refund',
      name: 'Transaction_Manage_Refund',
      component: () => import('@/views/paycools/data-agent/refund.vue'),
      meta: {
        title: 'refund', noCache: false,
        auth: ['ROLE_AUTH_AGENT_ADMIN']
      }
    },
    {
      path: 'payout',
      name: 'Transaction_Manage_Agent_Payout',
      component: () => import('@/views/paycools/data-agent/payout.vue'),
      meta: {
        title: 'payout', noCache: false,
        auth: ['ROLE_AUTH_AGENT_ADMIN']
      }
    }
  ]
}
